import { useEffect } from "react";

export function useSeo(title, description, path) {
  useEffect(() => {
    document.title = `${title} | Balqis Book`;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${window.location.origin}${path}`;
  }, [title, description, path]);
}
